export class DunningProcedure {
    ID: number;
    Code: string;
    Name: string;
    Inactive?: boolean;
    FullName?: string;
}

export default DunningProcedure;